import { useState } from 'react'
import { newRequestId } from '../core/api/http'

/**
 * Een idempotentiesleutel per *inhoud* van een formulier. Zelfde inhoud = zelfde id: een dubbelklik
 * of een herhaling na een weggevallen antwoord boekt niet dubbel. Andere inhoud (Sarah koos een
 * andere tijd of een ander bedrag) = nieuw id: anders geeft de server stil het vorige resultaat terug.
 *
 * `fingerprint`: een string van alles wat naar de server gaat, bijv. `JSON.stringify(payload)`.
 * Na een mislukte poging blijft het id gelijk: bij een weggevallen antwoord kan de eerste poging
 * wél gelukt zijn, en dan moet de herhaling dat antwoord terugkrijgen in plaats van opnieuw te boeken.
 *
 * Bijhouden via state (het React-patroon "waarde uit de vorige render"), niet door een ref te
 * overschrijven tijdens het renderen: dat blijft zuiver, ook als React een render overslaat of herhaalt.
 */
export function useRequestId(fingerprint: string): string {
  const [current, setCurrent] = useState(() => ({ fingerprint, id: newRequestId() }))
  if (current.fingerprint !== fingerprint) {
    const next = { fingerprint, id: newRequestId() }
    setCurrent(next)
    return next.id
  }
  return current.id
}
